import { TradeInfo } from '../services/token.service';
import { Trade } from '@/lib/stores/wsTokenSlice';

export function uniqBy<T extends Record<string, any>>(
  array: T[],
  key: string,
): T[] {
  const seen = new Map();
  return array.filter((item) => {
    const val = item[key];
    if (seen.has(val)) {
      return false;
    }
    seen.set(val, true);
    return true;
  });
}

export function handleTradeList(
  oldData: TradeInfo[],
  _data: Trade[],
): TradeInfo[] {
  if (_data) {
    if (
      _data.length > 0 &&
      oldData.length > 0 &&
      _data[0].pair_address !== oldData?.[0]?.pairAddress
    ) {
      return [];
    }
    return [
      ..._data.map((item) => ({
        chainId: item.chain_id,
        pairAddress: item.pair_address,
        to: item.to,
        tradeType: `${item.trade_type}`,
        baseTokenAmount: item.base_token_amount,
        tokenAmount: item.token_amount,
        baseTokenPriceUsd: item.base_token_price_usd,
        totalUsd: item.total_usd,
        tokenPriceUsd: item.token_price_usd,
        blockNum: '',
        txHash: item.tx_hash,
        clampType: '',
        maker: item.maker,
        sort: '',
        blockTimestamp: `${item.block_timestamp}`,
        swapName: item.swap_name,
        tokenAddress: item.token_address,
      })),
      ...oldData,
    ];
  }
  return oldData;
}
